/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 * A todo belongs to exactly one owner: set either \[companyId\] or \[carrierIdentifier\], not both. The controller validates this (mirroring the DB CHECK constraint) and returns 400 otherwise.
 * @export
 * @interface CreateTodoRequest
 */
export interface CreateTodoRequest {
  /**
   *
   * @type {string}
   * @memberof CreateTodoRequest
   */
  companyId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateTodoRequest
   */
  carrierIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateTodoRequest
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof CreateTodoRequest
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateTodoRequest
   */
  assignee: string;
  /**
   *
   * @type {LocalDate}
   * @memberof CreateTodoRequest
   */
  date?: LocalDate | null;
  /**
   *
   * @type {LocalDate}
   * @memberof CreateTodoRequest
   */
  deadline?: LocalDate | null;
}

/**
 * Check if a given object implements the CreateTodoRequest interface.
 */
export function instanceOfCreateTodoRequest(
  value: object,
): value is CreateTodoRequest {
  if (!("title" in value) || value["title"] === undefined) return false;
  if (!("assignee" in value) || value["assignee"] === undefined) return false;
  return true;
}

export function CreateTodoRequestFromJSON(json: any): CreateTodoRequest {
  return CreateTodoRequestFromJSONTyped(json, false);
}

export function CreateTodoRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateTodoRequest {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    title: json["title"],
    description: json["description"] == null ? undefined : json["description"],
    assignee: json["assignee"],
    date: json["date"] == null ? undefined : json["date"],
    deadline: json["deadline"] == null ? undefined : json["deadline"],
  };
}

export function CreateTodoRequestToJSON(json: any): CreateTodoRequest {
  return CreateTodoRequestToJSONTyped(json, false);
}

export function CreateTodoRequestToJSONTyped(
  value?: CreateTodoRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    carrierIdentifier: value["carrierIdentifier"],
    title: value["title"],
    description: value["description"],
    assignee: value["assignee"],
    date: value["date"],
    deadline: value["deadline"],
  };
}
